import { render, staticRenderFns } from "./SortBlock.vue?vue&type=template&id=18cb5dc0&scoped=true"
import script from "./SortBlock.vue?vue&type=script&lang=js"
export * from "./SortBlock.vue?vue&type=script&lang=js"
import style0 from "./SortBlock.vue?vue&type=style&index=0&id=18cb5dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cb5dc0",
  null
  
)

export default component.exports